export const sortByTranslatedLabel = (
    t: (key: string) => string,
    items: Array<{ label: string }>
) => items.sort((a, b) => t(a.label).localeCompare(t(b.label)));

export const moveToTop = (
    t: (key: string) => string,
    items: Array<{ label: string; value: string }>,
    topItems: string[]
) => {
    const top = items.filter((item) => topItems.includes(item.label));
    const rest = items.filter((item) => !topItems.includes(item.label));
    return [...top, ...sortByTranslatedLabel(t, rest)];
};
